import { Component } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CrewSelfService } from 'src/app/shared/services/crew-self.service';

@Component({
  selector: 'app-corporate-safety',
  templateUrl: './corporate-safety.component.html',
  styleUrls: ['./corporate-safety.component.scss'],
})
export class CorporateSafetyComponent{

  tabs = [
    { key: 'Open Reporting', value: 'Open Reporting' },
    { key: 'Stop Work Authority', value: 'Stop Work Authority' },
    { key: 'Safe Harbour', value: 'Safe Harbour' },
  ];
  isDesktop: boolean = true;
  public subscription: Subscription;
  public selectedTab: string = 'Open Reporting';
  constructor(private readonly router: Router, private readonly crewSelfService: CrewSelfService) {
    this.watchRouteChanges();
    this.subscription = this.crewSelfService.isDesktopGet().subscribe((event) => {
      this.isDesktop = event;
    })
  }
 
  clickOnPageTab(tab: string) {
    this.selectedTab = tab;
  }

  watchRouteChanges() {
    this.subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.selectedTab = 'Open Reporting';
      }
    });
  }
}
